$(function() {
    $(".faq-item").on('click', function(){
        var content = $(this).parent().find('.section__card-body').first();

        $('.section__card-body').not(content[0]).hide(300);
        $('.section_faqs .fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');

        if(content.is(":visible")){
            $(this).find($(".fa"))
                .removeClass('fa-angle-up')
                .addClass('fa-angle-down');
        } else {
            $(this).find($(".fa"))
                .removeClass('fa-angle-down')
                .addClass('fa fa-angle-up');
        }

        content.toggle(300);
    });
});
